import * as React from "react";
import { Navbar, NavDropdown } from "react-bootstrap";
import {Redirect, Link} from "react-router-dom";
import "./index.scss";

interface IProps {
    loggedIn: boolean;
    logout: () => boolean;
    name: string;
}

interface IState {

}

export default class extends React.Component<IProps, IState> {

    openMenu(){
        if (document.querySelector(".side-bar")){
            const element : any = document.querySelector(".side-bar");
            element.className =  element.className.includes("d-none") ? "side-bar d-sm-block" : "side-bar d-none d-sm-block";
        }
    }

    render(){
        return (
            <Navbar variant="dark">
                <div className="menu-button d-block d-sm-none mr-2" onClick={() => this.openMenu()}>
                    <i className="material-icons">
                        menu
                    </i>
                </div>
                <Navbar.Brand>Stage<span className="logo-gate">gate</span></Navbar.Brand>
                {
                    this.props.loggedIn ? 
                    <div className="right d-flex align-items-center">
                        <div className=" drop-down-menu d-flex align-items-center">
                            <div className="d-flex align-items-center">
                                <div className="background mr-3">
                                    <i className="material-icons">
                                        person
                                    </i>
                                </div>
                                {this.props.name}
                            </div>
                            <NavDropdown title="" id="nav-dropdown">
                                <NavDropdown.Item eventKey="4.4" onClick={() => {
                                    this.props.logout() && <Redirect to="/login" />
                                }}>Logout</NavDropdown.Item>
                            </NavDropdown>
                        </div> 
        
                        <div className="comments">
                            <img src={require("../../assets/messenger.svg")} />
                        </div> 
        
                        <div className="notifications">
                            <img src={require("../../assets/notifications.svg")} />
                        </div>  
        
                        <div className="settings">
                            <Link to="/settings">
                                <img src={require("../../assets/settings_header.svg")} />
                            </Link>
                        </div>      
        
                    </div> : null
                }
            </Navbar>
        )
    }
}